import { useSearchParams } from 'react-router-dom';
export const CARD_TABS = [
    { key: 'profile', label: 'Профиль' },
    { key: 'subscription', label: 'Подписка' },
    { key: 'balance', label: 'Баланс' },
    { key: 'payment', label: 'Оплата' },
    { key: 'actions', label: 'Действия' },
    { key: 'invitees', label: 'Приглашённые' },
    { key: 'deletion', label: 'Удаление' },
];
const KEYS = CARD_TABS.map((t) => t.key);
const LEGACY_TABS = {
    payments: 'balance',
    locations: 'subscription',
};
/**
 * The open tab of the user card, kept in the address (`&tab=balance`) so a link can
 * point straight at it. Switching tabs replaces the history entry — Back still
 * closes the card rather than walking back through tabs.
 */
export function useCardTab() {
    const [params, setParams] = useSearchParams();
    const raw = params.get('tab') ?? '';
    const tab = LEGACY_TABS[raw] ?? (KEYS.includes(raw) ? raw : 'profile');
    const setTab = (next) => setParams((prev) => {
        const p = new URLSearchParams(prev);
        if (next === 'profile')
            p.delete('tab');
        else
            p.set('tab', next);
        return p;
    }, { replace: true });
    return [tab, setTab];
}
